const SAFE_HREF_SCHEMES = ['http', 'https', 'mailto'];

// An href is safe to emit only if it is non-empty and either scheme-less (relative/anchor) or
// carries an allowlisted scheme.
//
// Every C0 control and space is stripped before scheme detection, matching the normalisation a
// browser performs: the URL Standard discards leading C0 controls and spaces before parsing, so a
// value like `<U+0001>javascript:alert(1)` reaches the parser as `javascript:alert(1)` and
// executes. Stripping only /\s+/ would leave those bytes in place, the scheme regex would fail to
// match, and the value would be misclassified as scheme-less and waved through. The range is the
// same one DOMPurify uses for attribute whitespace, so the two agree on what a scheme is.
//
// Shared by the HTML emit path in block.js and by the legacy DraftJS link plugin, which reads a
// JIRA_INLINECARD's href straight into an <a href> and a window.open with no serializer or
// sanitizer in between. DOMPurify covers the first; nothing covers the second, so this function is
// the only guard there. A second copy of the allowlist would be free to drift from this one.
export function isSafeHref(href) {
	if (!href) {
		return false;
	}
	// Matching control characters is the entire purpose here: they are what an attacker uses to
	// hide a scheme from the check below.
	// eslint-disable-next-line no-control-regex
	const normalized = href.replace(/[\u0000-\u0020]+/g, '');
	const schemeMatch = normalized.match(/^([a-z][a-z0-9+.-]*):/i);
	return !schemeMatch || SAFE_HREF_SCHEMES.includes(schemeMatch[1].toLowerCase());
}
